import { atom } from "jotai";

export const clinicAtom = atom({
  id: "",
  name: "",
  BHARATHEALPOINT_LOGO: "",
  BHARATHEALPOINT_LOGO_WITH_DES: "",
});

export const pharmacyAtom = atom({
  id: "",
  name: "",
});

export const permissionAtom = atom({
  role: "",
  allowed_features: [],
});

export const doctorListAtom = atom([]);
export const selectedDoctorAtom = atom(null);
export const allClinicsAtom = atom([]);
export const allPharmacyAtom = atom([]);
export const doctorSettingAtom = atom({
  consultation_setup: [],
  // doctor_user: "",
  edit_invoice_permissions: "",
  invoice_on_end_consultation: "",
  is_online_appointment: "",
  prescription_setup: [],
  header_footer_setup: {
    A3: {
      headerHeight: "3",
      footerHeight: "3",
      pageSize: "A3",
      headerUrl: "",
      footerUrl: "",
    },
    A4: {
      headerHeight: "3",
      footerHeight: "3",
      pageSize: "A4",
      headerUrl: "",
      footerUrl: "",
    },
    A5: {
      headerHeight: "3",
      footerHeight: "3",
      pageSize: "A5",
      headerUrl: "",
      footerUrl: "",
    },
  },
  // user_created: "",
});

export const allPatientDataAtom = atom({
  isGrid: true,
  searchData: "",
  allData: [],
  scrollPosition: 0,
  currentPage: 1,
  perPageLimit: "",
  totalPages: 1,
  data: [],
});

// export const showPopupAtom = atom(false);
// export const popupTaskAtom = atom(null);
